import React from "react";
import styles from "./Style.module.css";
import { ArrowBackIos, Edit } from "@mui/icons-material";
import history from "../../../libs/history.utils";
import useQuizDetail from "./QuizDetail.hook";
import ShadowBox from "../../../components/ShadowBox/ShadowBox";
import { ButtonBase, CardMedia, Typography, Box } from "@mui/material";
import StatusPill from "../../../components/Status/StatusPill.component";
import capitalizeFirstLetter from "../../../hooks/CommonFunction";
import { ArrowOutlineButton } from "../../../components/Buttons/PrimaryButton";
import duplicate from "../../../assets/CRMAssets/ic_duplicate_orange@2x.png";
import useRoles from "../../../hooks/RoleHook";
import Constants from "../../../config/constants";

function QuizDetail() {
  const { data , handleEdit, handleCopy} = useQuizDetail({});
  const {canDelete, canRead, canCreate, canUpdate} = useRoles(Constants.MODULES.QUIZES_MODULE);
  return (
    <div>
      <div className={styles.outerFlex1}>
        <div className={styles.iconButton}>
          <div className={styles.arrowWrap}>
            <ButtonBase onClick={() => history.goBack()}>
              <ArrowBackIos fontSize={"small"} />{" "}
            </ButtonBase>
            <Typography variant={"title1"}>Quiz Detail</Typography>
          </div>
          <div className={styles.buttonRow}>
          {/* {canCreate &&<ArrowOutlineButton
             onClick={handleCopy}
            icon={<img src={duplicate} alt="duplicate" className={styles.duplicate}/>}
            
          >
            DUPLICATE
          </ArrowOutlineButton>} */}
          {canUpdate && <ArrowOutlineButton
             onClick={handleEdit}
            icon={<Edit fontSize="normal" />}
          >
            Edit
          </ArrowOutlineButton>}
          </div>
        </div>
        <ShadowBox
          className={styles.Container}
          sx={{
            p: 2,
            borderRadius: 2,
            boxShadow: 1,
          }}
        >
          <img
            src={data?.image}
            className={styles?.imageWrap}
            crossOrigin="anonymous"
          />

          {/* Content Section */}
          <Box sx={{ flexGrow: 1, ml: 2 }}>
            <div>
              <Typography variant="h6" component="div" fontWeight="bold">
                {capitalizeFirstLetter(data?.title)}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {capitalizeFirstLetter(data?.description)}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {data?.startDateText}
              </Typography>
              {/* <Typography variant="body2" color="text.secondary">
                <strong>Priority:</strong> {data?.priority}
              </Typography> */}
              <Typography variant="body2" color="text.secondary">
                <strong>
                  Client: {capitalizeFirstLetter(data?.client?.name)}
                </strong>
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>
                  Associated Program:{" "}
                  {data?.programs?.map((val) => val?.name)?.join(" , ")}
                </strong>
              </Typography>
              <Typography variant="body2" color="text.secondary">
                <strong>
                  Total Reward Points:
                  {data?.total_reward_points}{" "}
                </strong>
              </Typography>
            </div>
          </Box>

          <Box>
            <StatusPill status={data?.status} color={data?.status} />
          </Box>
        </ShadowBox>
        <ShadowBox
          className={styles.Container21}
          sx={{
            p: 2,
            borderRadius: 2,
            boxShadow: 1,
          }}
        >
          <Typography variant="h6" component="div" fontWeight="bold">
            Question Details ({data?.total_questions})
          </Typography>
          {data?.questions?.map((val, index) => (
            <>
              <div className={styles.optCont} key={`options_${index}`}>
                <img
                  src={val?.image}
                  className={styles?.imageWrap}
                  crossOrigin="anonymous"
                />

                <Box sx={{ flexGrow: 1, ml: 2 }}>
                  <div>
                    <Typography variant="h6" component="div" fontWeight="bold">
                      {capitalizeFirstLetter(val?.question)}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      {capitalizeFirstLetter(val?.description)}
                    </Typography>
                    <Typography variant="body2" color="text.secondary">
                      <strong>
                        {val?.reward_points} Reward Point
                        {val?.reward_points !== 1 && "s"}
                      </strong>
                    </Typography>
                    <div className={styles.optWrap}>
                      {val?.options?.map((opt, questInd) => (
                        <Typography
                          variant="body1"
                          color="text.secondary"
                          fontWeight="bold"
                        >
                          Option {questInd + 1}:{" "}
                          <span
                            className={
                              opt?.is_correct ? styles?.correctOpt : ""
                            }
                          >
                            {capitalizeFirstLetter(opt?.value)}{" "}
                          </span>
                        </Typography>
                      ))}
                    </div>
                  </div>
                </Box>
              </div>
              {data?.questions?.length !== index + 1 && (
                <div className={styles.horizontalLine}></div>
              )}
            </>
          ))}
        </ShadowBox>
      </div>
    </div>
  );
}

export default QuizDetail;
